<template>
    <div>
        <div class="signal_light"
            @click="InitiateSpeedDetection"
            :data-tooltip="$t('ui.toolbox.speed_test.network_quality')+': ' + speed_text"
            data-position="bottom right"
            v-if="display_mode == 'basic'"
            :class="{ 'green': speed_level == 'good', 'red': speed_level == 'bad', 'orange': speed_level == 'medium' }">
        </div>
        <div class="ui left labeled button" v-else tabindex="0">
            <a class="ui basic label" :class="{ 'green': speed_level == 'good', 'red': speed_level == 'bad', 'orange': speed_level == 'medium' }">
                <!-- 連線品質 -->
                {{ $t('ui.toolbox.speed_test.network_quality') }}: {{ speed_text }}
            </a>
            <div class="ui icon button" @click="InitiateSpeedDetection">
                <i class="refresh icon"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            display_mode: "basic",
            imageAddr: "https://www.google.com.tw/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png",
            downloadSize: 13504,
            // imageAddr: "http://www.kenrockwell.com/contax/images/g2/examples/31120037-5mb.jpg",
            // downloadSize: 4995374, //bytes
            speedBps: null,
            speedKbps: null,
            speedMbps: null,
            speed_text: null,
            speed_level: null,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.InitiateSpeedDetection()
    },
    watch: {
    },
    methods: {
        ShowProgressMessage(msg) {
            this.speed_text = msg
        },
        InitiateSpeedDetection() {
            this.ShowProgressMessage("Measuring...")
            window.setTimeout(this.MeasureConnectionSpeed(), 1)
        },
        MeasureConnectionSpeed() {
            var that = this
            var startTime, endTime
            var download = new Image()
            download.onload = () => {
                endTime = (new Date()).getTime()
                showResults()
            }

            download.onerror = function (err, msg) {
                that.ShowProgressMessage("Invalid image, or error downloading")
            }

            startTime = (new Date()).getTime()
            var cacheBuster = "?nnn=" + startTime
            download.src = this.imageAddr + cacheBuster

            function showResults() {
                var duration = (endTime - startTime) / 1000
                var bitsLoaded = that.downloadSize * 8
                var speedBps = (bitsLoaded / duration).toFixed(2)
                var speedKbps = (speedBps / 1024).toFixed(2)
                var speedMbps = (speedKbps / 1024).toFixed(2)
                that.speedBps = speedBps
                that.speedKbps = speedKbps
                that.speedMbps = speedMbps
                if (speedKbps > 1024) {
                    that.speed_level = "good"
                } else if (speedKbps > 512) {
                    that.speed_level = "medium"
                } else {
                    that.speed_level = "bad"
                }
                that.ShowProgressMessage(speedKbps + " Kbps")
            }
        },
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
.signal_light {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background: white;
    &.red {
        background: #db2828;
    }
    &.orange {
        background: #f26202;
    }
    &.green {
        background: #21ba45;
    }
}
.ui.label {
    font-weight: 500;
}
</style>
